import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';
export const getClasses = createAsyncThunk('department/get', async () => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/department/',
      method: 'GET',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return 'error';
  }
});
export const getMonths = createAsyncThunk('months/get', async () => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/attendance/months',
      method: 'GET',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return 'error';
  }
});
export const getAcademicClasses = createAsyncThunk(
  //Getting class Details of studnet in Edit Page
  'AcademicData/get',
  async (email) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/department/academic',
        method: 'GET',
        headers: { email: email },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const AddNode = createAsyncThunk('department/ADD', async (NewData) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/department/',
      method: 'POST',
      data: NewData,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const EditNode = createAsyncThunk('department/PUT', async (NewData) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/department/',
      method: 'PUT',
      data: NewData,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const DeleteNode = createAsyncThunk(
  'department/DEL',
  async (NewData) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/department/',
        method: 'DELETE',
        data: NewData,
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const postNewlyAddedClasses = createAsyncThunk(
  'department/post2',
  async (NewClasses) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/department/',
        method: 'PUT',
        data: NewClasses,
      });
      return response?.status;
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteDepartment = createAsyncThunk(
  'department/delete',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/department/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const updateDepartment = createAsyncThunk(
  'department/update',
  async (obj) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/department/dept',
        method: 'PUT',
        data: obj,
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteClass = createAsyncThunk('class/delete', async (id) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/department/classes/${id}`,
      method: 'DELETE',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const updateClass = createAsyncThunk('class/update', async (obj) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/department/classes',
      method: 'PUT',
      data: obj,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const deleteSection = createAsyncThunk('section/delete', async (id) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/department/section/${id}`,
      method: 'DELETE',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const updateSection = createAsyncThunk('section/update', async (obj) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/department/dept',
      method: 'PUT',
      data: obj,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
const notificationSlice = createSlice({
  name: 'notifications',
  initialState: [],
  reducers: {},
});
export default notificationSlice.reducer;
